import React from 'react'

export default function IconsTemplateOutline(props) {
    return (
        <svg {...props} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M16.6667 2.5H3.33333C2.8731 2.5 2.5 2.8731 2.5 3.33333V7.5C2.5 7.96024 2.8731 8.33333 3.33333 8.33333H16.6667C17.1269 8.33333 17.5 7.96024 17.5 7.5V3.33333C17.5 2.8731 17.1269 2.5 16.6667 2.5Z'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.16667 11.6665H3.33333C2.8731 11.6665 2.5 12.0396 2.5 12.4998V16.6665C2.5 17.1267 2.8731 17.4998 3.33333 17.4998H9.16667C9.6269 17.4998 10 17.1267 10 16.6665V12.4998C10 12.0396 9.6269 11.6665 9.16667 11.6665Z'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.6654 11.6665H14.1654C13.7051 11.6665 13.332 12.0396 13.332 12.4998V16.6665C13.332 17.1267 13.7051 17.4998 14.1654 17.4998H16.6654C17.1256 17.4998 17.4987 17.1267 17.4987 16.6665V12.4998C17.4987 12.0396 17.1256 11.6665 16.6654 11.6665Z'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
